import React from "react";
import { motion } from "framer-motion";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import CustomInput from "Common/CustomInput/CustomInput";
import CustomSelect from "Common/CustomSelect/CustomSelect";
import SuperAccordion from "Components/SuperAccordion/SuperAccordion";
import { GENDER_OPTIONS } from "Common/Constants";
import MaskPhoneNumber from "Utils/MaskPhoneNumber";
import PropTypes from "prop-types";

const Guarantor = ({
  ptModel,
  validationModel,
  showOnlyRequired,
  sectionsOpen,
  onToggleSection,
  handleChange,
  onPasteZip,
}) => {
  const showGuarantorSection = ptModel.GuarantorRelation && ptModel.GuarantorRelation !== "18";

  if (!showGuarantorSection) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
      className="border rounded-lg p-4"
    >
      <div
        className="flex items-center justify-between cursor-pointer py-2"
        onClick={() => onToggleSection("guarantor")}
      >
        <h3 className="text-lg font-medium text-gray-900">Guarantor</h3>
        {sectionsOpen.guarantor ? (
          <FiChevronUp className="text-gray-500" />
        ) : (
          <FiChevronDown className="text-gray-500" />
        )}
      </div>
      <SuperAccordion show={sectionsOpen.guarantor}>
        <div className="space-y-4 mt-4">
          {showOnlyRequired ? (
            <>
              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 md:col-span-6">
                  <CustomInput
                    toLower
                    onChange={handleChange}
                    name="firstName"
                    data-nested="patientGuarantor.firstName"
                    value={ptModel.patientGuarantor?.firstName || ""}
                    required
                    label="First Name"
                    placeholder="First Name"
                  />
                  {validationModel.guarantorFirstNameError}
                </div>
                <div className="col-span-12 md:col-span-6">
                  <CustomInput
                    toLower
                    onChange={handleChange}
                    name="lastName"
                    data-nested="patientGuarantor.lastName"
                    value={ptModel.patientGuarantor?.lastName || ""}
                    required
                    label="Last Name"
                    placeholder="Last Name"
                  />
                  {validationModel.guarantorLastNameError}
                </div>
              </div>

              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 md:col-span-6">
                  <CustomInput
                    onChange={handleChange}
                    name="dob"
                    data-nested="patientGuarantor.dob"
                    value={ptModel.patientGuarantor?.dob || ""}
                    type="date"
                    required
                    label="Date Of Birth"
                  />
                  {validationModel.guarantorDobError}
                </div>
                <div className="col-span-12 md:col-span-6">
                  <CustomSelect
                    name="gender"
                    data-nested="patientGuarantor.gender"
                    value={ptModel.patientGuarantor?.gender || ""}
                    onChange={handleChange}
                    required
                    label="Gender"
                  >
                    {GENDER_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </CustomSelect>
                  {validationModel.guarantorGenderError}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 md:col-span-4">
                  <CustomInput
                    toLower
                    onChange={handleChange}
                    name="firstName"
                    data-nested="patientGuarantor.firstName"
                    value={ptModel.patientGuarantor?.firstName || ""}
                    required
                    label="First Name"
                    placeholder="First Name"
                  />
                  {validationModel.guarantorFirstNameError}
                </div>
                <div className="col-span-12 md:col-span-4">
                  <CustomInput
                    toLower
                    onChange={handleChange}
                    name="middleName"
                    data-nested="patientGuarantor.middleName"
                    value={ptModel.patientGuarantor?.middleName || ""}
                    label="Middle Name"
                    placeholder="Middle Name"
                  />
                </div>
                <div className="col-span-12 md:col-span-4">
                  <CustomInput
                    toLower
                    onChange={handleChange}
                    name="lastName"
                    data-nested="patientGuarantor.lastName"
                    value={ptModel.patientGuarantor?.lastName || ""}
                    required
                    label="Last Name"
                    placeholder="Last Name"
                  />
                  {validationModel.guarantorLastNameError}
                </div>
              </div>

              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 md:col-span-6">
                  <CustomInput
                    onChange={handleChange}
                    name="dob"
                    data-nested="patientGuarantor.dob"
                    value={ptModel.patientGuarantor?.dob || ""}
                    type="date"
                    required
                    label="Date Of Birth"
                  />
                  {validationModel.guarantorDobError}
                </div>
                <div className="col-span-12 md:col-span-6">
                  <CustomSelect
                    name="gender"
                    data-nested="patientGuarantor.gender"
                    value={ptModel.patientGuarantor?.gender || ""}
                    onChange={handleChange}
                    required
                    label="Gender"
                  >
                    {GENDER_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </CustomSelect>
                  {validationModel.guarantorGenderError}
                </div>
              </div>

              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 md:col-span-4">
                  <CustomInput
                    onChange={handleChange}
                    name="email"
                    data-nested="patientGuarantor.email"
                    value={ptModel.patientGuarantor?.email || ""}
                    label="Email"
                    type="email"
                    autoComplete="off"
                    placeholder="Email"
                  />
                </div>
                <div className="col-span-12 md:col-span-4">
                  <CustomInput
                    onChange={handleChange}
                    name="mobileNumber"
                    data-nested="patientGuarantor.mobileNumber"
                    value={MaskPhoneNumber(ptModel.patientGuarantor?.mobileNumber || "", "generatemask")}
                    label="Mobile Number"
                    placeholder="Mobile Number"
                  />
                </div>
                <div className="col-span-12 md:col-span-4">
                  <CustomInput
                    onChange={handleChange}
                    name="phoneNumber"
                    data-nested="patientGuarantor.phoneNumber"
                    value={MaskPhoneNumber(ptModel.patientGuarantor?.phoneNumber || "", "generatemask")}
                    label="Phone Number"
                    placeholder="Phone Number"
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 md:col-span-12">
                  <CustomInput
                    toLower
                    onChange={handleChange}
                    name="address1"
                    data-nested="patientGuarantor.address1"
                    value={ptModel.patientGuarantor?.address1 || ""}
                    label="Street Address" 
                    placeholder="Street Address"
                  />
                </div>
              </div>

              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 md:col-span-4">
                  <CustomInput
                    name="city"
                    data-nested="patientGuarantor.city"
                    value={ptModel.patientGuarantor?.city || ""}
                    disabled={true}
                    label="City"
                    placeholder="City"
                    toLower
                    toolTip="City and State will appear automatically once you enter a valid Zip Code."
                  />
                </div>
                <div className="col-span-12 md:col-span-4">
                  <CustomInput
                    name="state"
                    data-nested="patientGuarantor.state"
                    value={ptModel.patientGuarantor?.state || ""}
                    disabled={true}
                    label="State"
                    placeholder="State"
                  />
                </div>
                <div className="col-span-12 md:col-span-4">
                  <CustomInput
                    onInput={onPasteZip}
                    label="Zip Code"
                    placeholder="Zip Code"
                    name="zipCode"
                    data-nested="patientGuarantor.zipCode"
                    onChange={handleChange}
                    isNumeric
                    maxlength="9"
                    value={ptModel.patientGuarantor?.zipCode || ""}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </SuperAccordion>
    </motion.div>
  );
};

Guarantor.propTypes = {
  ptModel: PropTypes.object.isRequired,
  validationModel: PropTypes.object.isRequired,
  showOnlyRequired: PropTypes.bool.isRequired,
  sectionsOpen: PropTypes.object.isRequired,
  onToggleSection: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  onPasteZip: PropTypes.func.isRequired,
};

export default Guarantor;

